import { useState } from "react";
import { Container, Row, Col, Card, Form, Button, Toast,} from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash, FaLock } from "react-icons/fa";
import img12 from "../assets/bgimg.png";

export default function ChangePassword() {
  const navigate = useNavigate();

  const [oldpassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");

  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);

  const [errors, setErrors] = useState({});
  const [toast, setToast] = useState({
    show: false,
    message: "",
    bg: "danger",
  });

  /* Validation */
  const validate = () => {
    const newErrors = {};

    if (!oldpassword) {
      newErrors.password = "Please enter old password";
    } else if (oldpassword.length < 6) {
      newErrors.password = "Password must be at least 6 characters";
    }

    if (!newPassword) {
      newErrors.confirmPassword = "Please enter new  password";
    } else if (oldpassword !== newPassword) {
      newErrors.confirmPassword = "Don't match your old password ";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  /* Submit */
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validate()) return;

    setToast({
      show: true,
      message: "Password change password successfully",
      bg: "success",
    });

    setTimeout(() => {
      navigate("/");
    }, 1200);
  };

  return (
    <>

      <Toast
        show={toast.show}
        onClose={() => setToast({ ...toast, show: false })}
        delay={3000}
        autohide
        bg={toast.bg}
        style={{
          position: "fixed",
          top: 20,
          right: 20,
          zIndex: 2000,
        }}
      >
        <Toast.Body className="text-white">
          {toast.message}
        </Toast.Body>
      </Toast>

      {/*  --- >Background */}
      <div
        style={{
          minHeight: "100vh",
         backgroundImage: `url(${img12})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div
          style={{
            minHeight: "100vh",
            backdropFilter: "blur(6px)",
            backgroundColor: "rgba(0,0,0,0.25)",
            display: "flex",
            alignItems: "center",
          }}
        >
          <Container>
            <Row className="justify-content-center">
              <Col xl={4} lg={5} md={6} sm={10} xs={12}>
                <Card className="resetcard shadow-lg">
                  <Card.Body className="p-4 changepasswordcard-body text-white">

                    <h4 className="fw-bold text-center mb-2">
                      Change  Password
                    </h4>

                    <p className="text-center mb-4 opacity-75">
                      Update your password, upgrade your security
                    </p>

                    <Form onSubmit={handleSubmit}>

                      {/* New Password */}
                      <Form.Group className="mb-3">
                        <Form.Label>Old Password</Form.Label>

                        <div className="position-relative">
                          <Form.Control
                            type={showOldPassword ? "text" : "password"}
                            placeholder="Enter old password"
                            value={oldpassword}
                            onChange={(e) => setOldPassword(e.target.value)}
                            className="py-2 reset-input"
                          />

                          <span
                            className="position-absolute top-50 end-0 translate-middle-y me-3"
                            style={{ cursor: "pointer" }}
                            onClick={() => setShowOldPassword(!showOldPassword)}
                          >
                            {showOldPassword ? (
                              <FaEye style={{ color: "#f4c430" }} />
                            ) : (
                              <FaEyeSlash style={{ color: "#2d0c57" }} />
                            )}
                          </span>
                        </div>

                        {errors.password && (
                          <small className="text-danger">
                            {errors.password}
                          </small>
                        )}
                      </Form.Group>

                      {/* Confirm Password */}
                      <Form.Group className="mb-2">
                        <Form.Label>New Password</Form.Label>

                        <div className="position-relative">
                          <Form.Control
                            type={showNewPassword ? "text" : "password"}
                            placeholder="Enter new password"
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                            className="py-2 reset-input"
                          />

                          <span
                            className="position-absolute top-50 end-0 translate-middle-y me-3"
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              setShowNewPassword(!showNewPassword)
                            }
                          >
                            {showNewPassword ? (
                              <FaEye style={{ color: "#f4c430" }} />
                            ) : (
                              <FaEyeSlash style={{ color: "#2d0c57" }} />
                            )}
                          </span>
                        </div>

                        {errors.confirmPassword && (
                          <small className="text-danger">
                            {errors.confirmPassword}
                          </small>
                        )}
                      </Form.Group>

                      <div className="d-flex justify-content-end mb-3">
                        <Button
                          variant="link"
                          className="p-0 text-decoration-none"
                          style={{ color: "#2d0c57" }}
                          onClick={() => navigate("/")}
                        >
                          Login
                        </Button>
                      </div>

                      <div className="d-flex justify-content-center align-items-center">
                        <button
                          type="submit"
                          className="w-100  p-2 submit-btn change-btn"
                        >
                          Change  Password
                        </button>
                      </div>
                    </Form>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </>
  );
}
